import React, { useEffect } from 'react';
import { Grid } from '@ts/storybook';
import Misc from '@components/Misc';
import DataTable from '@modules/DataTable';
import EventGenerationRules from '../EventGenerationRules/EventGenerationRules';
import NeedsManager from '@utils/NeedsManager';
import ReadingTypes from '../ReadingTypes/ReadingTypes';
import { IForm } from '@ts/ui-models';

interface IDeviceTypeEventsProps extends IForm {}

const DeviceTypeEvents = ({ values }: IDeviceTypeEventsProps) => {
  const renderEventRules = () => <EventGenerationRules title="Events" id={values.id} />;

  const renderReadingsDevice = () => (
    <ReadingTypes title="Readings type" fetchURL={`/api/readingTypesofDeviceType/${values.id}`} />
  );

  return (
    <Grid container spacing={2} size={12}>
      {renderEventRules()}
      {renderReadingsDevice()}
    </Grid>
  );
};

export default DeviceTypeEvents;
